import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Kategorien
const GAME_TYPES = ["Ruf", "Sticht", "Tout", "Sonstige"];
const COLORS = ["Schellen", "Grün", "Eichel", "Herz"];

const BASE_GAMES = {
  Ruf: COLORS.map((c) => `Ruf-${c}`),
  Sticht: COLORS.map((c) => `${c}-Sticht`),
  Tout: [
    "Wenz-Tout",
    "Geier-Tout",
    ...COLORS.map((c) => `${c}-Tout`),
  ],
  Sonstige: ["Weg", "Bettel", "Auflage", "Wenz", "Geier", "Kreuz", "Hochzeit"],
};

const GAME_ICONS = {
  Weg: "fa-solid fa-person-walking",
  Bettel: "fa-solid fa-ban",
  Auflage: "fa-solid fa-layer-group",
  Wenz: "fa-solid fa-chess-king",
  Geier: "fa-solid fa-dove",
  Kreuz: "fa-solid fa-cross",
  Ruf: "fa-solid fa-bullhorn",
  Tout: "fa-solid fa-crown",
  Sticht: "fa-solid fa-dice",
};

export default function SchafkopfGameSelect({ chooseGame, cardToSwap }) {
  const [selectedType, setSelectedType] = useState(null);
  const [selectedGame, setSelectedGame] = useState(""); // Won stiche (tricks) for the player
  const availableGames =
    selectedType && BASE_GAMES[selectedType] ? BASE_GAMES[selectedType] : [];

  return (
    <div className="game-select">
      <h2>Wähle ein Spiel</h2>

      {/* Step 1: Typ wählen */}
      <div className="game-grid">
        {GAME_TYPES.map((type) => (
          <button
            key={type}
            onClick={() => {
              setSelectedType(type);
              setSelectedGame(null);
            }}
            className={`game-button ${selectedType === type ? "selected" : ""}`}
            id={type}
          >
            <FontAwesomeIcon icon={GAME_ICONS[type] || "fa-solid fa-gamepad"} size="2x" />
            <span>{type}</span>
          </button>
        ))}
      </div>

      {/* Step 2: Konkretes Spiel */}
      {selectedType && (
        <div className="game-options">
          <div className="game-grid">
            {availableGames.map((game) => (
              <button
                key={game}
                onClick={() => setSelectedGame(game)}
                className={`game-button ${selectedGame === game ? "selected" : ""}`}
                id={game}
              >
                <FontAwesomeIcon icon={GAME_ICONS[selectedType] || "fa-solid fa-dice"} />
                <span>{game}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Confirm Button */}
      <button
        className="confirm-button"
        onClick={() => chooseGame(selectedGame)}
        disabled={!selectedGame}
        id="confirm"
      >
        <FontAwesomeIcon icon="fa-solid fa-check" /> Bestätigen
      </button>
      <button
        onClick={() => {
          chooseGame("Weg");
        }}
        className={`game-button`}
      >
        <span>Weg</span>
      </button>
    </div>
  );
}